import React from 'react';
const EuFlag = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 810 540" },
    React.createElement("defs", null,
        React.createElement("g", { id: "eu_flag_d" },
            React.createElement("g", { id: "eu_flag_b" },
                React.createElement("path", { id: "eu_flag_a", d: "M0 0v1h.5z", transform: "rotate(18 3.157 -.5)" }),
                React.createElement("use", { xlinkHref: "#eu_flag_a", transform: "scale(-1 1)" })),
            React.createElement("g", { id: "eu_flag_c" },
                React.createElement("use", { xlinkHref: "#eu_flag_b", transform: "rotate(72)" }),
                React.createElement("use", { xlinkHref: "#eu_flag_b", transform: "rotate(144)" })),
            React.createElement("use", { xlinkHref: "#eu_flag_c", transform: "scale(-1 1)" }))),
    React.createElement("path", { fill: "#039", d: "M0 0h810v540H0z" }),
    React.createElement("g", { fill: "#fc0", transform: "matrix(30 0 0 30 405 270)" },
        React.createElement("use", { xlinkHref: "#eu_flag_d", y: "-6" }),
        React.createElement("use", { xlinkHref: "#eu_flag_d", y: "6" }),
        React.createElement("g", { id: "eu_flag_e" },
            React.createElement("use", { xlinkHref: "#eu_flag_d", x: "-6" }),
            React.createElement("use", { xlinkHref: "#eu_flag_d", transform: "rotate(-144 -2.344 -2.11)" }),
            React.createElement("use", { xlinkHref: "#eu_flag_d", transform: "rotate(144 -2.11 -2.344)" }),
            React.createElement("use", { xlinkHref: "#eu_flag_d", transform: "rotate(72 -4.663 -2.076)" }),
            React.createElement("use", { xlinkHref: "#eu_flag_d", transform: "rotate(72 -5.076 .534)" })),
        React.createElement("use", { xlinkHref: "#eu_flag_e", transform: "scale(-1 1)" }))));
export default EuFlag;
//# sourceMappingURL=eu.js.map